/* PackageDetailsComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PackageDetailsRenderer");
const _ = require("lodash");

class PackageDetailsComponent extends EventEmitter {
    constructor(details) {
        super();
        this._renderer = new Renderer(this);

        this._registerListeners();
        this.setDetails(details);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._renderer = undefined;
            //TODO set all class members to undefined here
            resolve();
        });
        this.emit("Shutdown");
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    get details() {
        return this.getDetails();
    }
    getDetails() {
        return this._details;
    }
    set details(d) {
        return this.setDetails(d);
    }
    setDetails(d, silent) {
        let old = _.cloneDeep(this.details);
        this._details = d;
        if (!silent) {
            this.emit("DetailsReplaced", this.details, old);
        }
        return this;
    }
    get name() {
        return this.getName();
    }
    getName() {
        return _.get(this.details, "name", "");
    }
    get version() {
        return this.getVersion();
    }
    getVersion() {
        return _.get(this.details, "semVersion", "");
    }
    get description() {
        return this.getDescription();
    }
    getDescription() {
        return _.get(this.details, "description", "");
    }
    get releaseNotes() {
        return this.getReleaseNotes();
    }
    getReleaseNotes() {
        return _.get(this.details, "releaseNotes", "");
    }
    get createTime() {
        return this.getCreateTime();
    }
    getCreateTime() {
        return _.get(this.details, "createTime", undefined);
    }
    get createUser() {
        return this.getCreateUser();
    }
    getCreateUser() {
        return _.get(this.details, "createUser", "");
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = PackageDetailsComponent;
